// extracted by mini-css-extract-plugin
export var actions = "_6k-8";
export var arrow = "_6k-5";
export var card = "_6k-0";
export var cardWrapper = "_6k-9";
export var fieldName = "_6k-3";
export var newValue = "_6k-6";
export var oldValue = "_6k-4";
export var orangeGlowFade = "_6k-c";
export var productSection = "_6k-1";
export var scrollToBottom = "_6k-b";
export var scrollToBottomAnchor = "_6k-a";
export var scrollToBottomIcon = "_6k-d";
export var showAllButton = "_6k-7";
export var table = "_6k-2";